import axios from "axios";

async function sendOTPMessage(body) {
	const response = await axios.post(process.env.REACT_APP_PAYMENT_LINK_URL + "message/sendOTPMessage", body);
	return response;
}
async function sendOTPMessageMail(body) {
	const response = await axios.post(process.env.REACT_APP_PAYMENT_LINK_URL + "message/sendOTPMessageToMail", body);
	return response;
}
async function sendMailTo(body) {
	const response = await axios.post(process.env.REACT_APP_PAYMENT_LINK_URL + "mail/sendMailTo", body);
	return response;
}
async function sendOTPMessagePhone(body) {
	const response = await axios.post(process.env.REACT_APP_PAYMENT_LINK_URL + "message/sendOtpSms", body);
	return response;
}
async function sendOTPMessageToMailForKyc(body) {
	const response = await axios.post(process.env.REACT_APP_PAYMENT_LINK_URL + "message/sendOTPMessageToMailForKyc", body);
	return response;
}
export { sendOTPMessage, sendOTPMessageMail, sendMailTo, sendOTPMessagePhone, sendOTPMessageToMailForKyc };
